import React, { useState, useEffect } from 'react';
import { useContext } from 'react';
import { FirmProfileContext } from '../context/FirmProfileContext';
import { baseURL } from '../apiConfig';
import './TagwiseStock.css'; 

const TagwiseStock = () => {
  const { firmProfile } = useContext(FirmProfileContext);
  const [metal, setMetal] = useState('');
  const [purity, setPurity] = useState('');
  const [itemGroup, setItemGroup] = useState('');
  const [item, setItem] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  
  const [stockData, setStockData] = useState([]);
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(false);

  const [masterMetals, setMasterMetals] = useState([]);
  const [masterPurities, setMasterPurities] = useState([]);
  const [masterGroups, setMasterGroups] = useState([]);
  const [masterItems, setMasterItems] = useState([]);

  useEffect(() => {
    const loadInitialMetals = async () => {
      try {
        const response = await fetch(`${baseURL}/api/master/dropdowns/`);
        const data = await response.json();
        if (data.success) {
          setMasterMetals(data.metals || []);
        }
      } catch (error) {
        console.error("Master Table fetch error:", error);
      }
    };
    loadInitialMetals();
    fetchStockReport('', '', '', '', '');
  }, []);

  const handleMetalChange = async (e) => {
    const selectedMetal = e.target.value;
    setMetal(selectedMetal);
    
    // Niche ke fields force reset
    setPurity(''); setItemGroup(''); setItem('');
    setMasterPurities([]); setMasterGroups([]); setMasterItems([]);

    if (selectedMetal) {
      try {
        const response = await fetch(`${baseURL}/api/master/dropdowns/?metal=${selectedMetal}`);
        const data = await response.json();
        if (data.success) {
          setMasterPurities(data.purities || []);
        }
      } catch (error) {}
    }
  };

  const handlePurityChange = async (e) => {
    const selectedPurity = e.target.value;
    setPurity(selectedPurity);
    
    // Niche ke fields force reset
    setItemGroup(''); setItem('');
    setMasterGroups([]); setMasterItems([]);

    if (selectedPurity) {
      try {
        const response = await fetch(`${baseURL}/api/master/dropdowns/?metal=${metal}&purity=${selectedPurity}`);
        const data = await response.json();
        if (data.success) {
          setMasterGroups(data.groups || data.item_groups || []); 
        }
      } catch (error) {}
    }
  };

  // const handleGroupChange = async (e) => {
  //   const selectedGroup = e.target.value;
  //   setItemGroup(selectedGroup);
    
  //   // Niche ka Item field force reset
  //   setItem('');
  //   setMasterItems([]);

  //   if (selectedGroup) {
  //     try {
  //       // Backend compatibility ke liye 'group' aur 'item_group' dono parameters bhej diye hain
  //       const response = await fetch(`${baseURL}/api/master/dropdowns/?metal=${metal}&purity=${purity}&group=${selectedGroup}&item_group=${selectedGroup}`);
  //       const data = await response.json();
  //       if (data.success) {
  //         setMasterItems(data.items || data.item_names || []);
  //       }
  //     } catch (error) {}
  //   }
  // };

  const handleGroupChange = async (e) => {
    const selectedGroup = e.target.value;
    setItemGroup(selectedGroup);
    
    // Niche ka Item field force reset
    setItem('');
    setMasterItems([]);

    if (selectedGroup) {
      try {
        // Spaces ko URL safe banane ke liye encodeURIComponent use kiya hai
        const safeMetal = encodeURIComponent(metal);
        const safePurity = encodeURIComponent(purity);
        const safeGroup = encodeURIComponent(selectedGroup);

        const response = await fetch(`${baseURL}/api/master/dropdowns/?metal=${safeMetal}&purity=${safePurity}&item_group=${safeGroup}&group=${safeGroup}`);
        const data = await response.json();
        
        if (data.success) {
          // 🔥 YAHAN HAI EXACT NAAM JO SCREENSHOT ME MILA: data.itemNames
          setMasterItems(data.itemNames || []);
        }
      } catch (error) {
        console.error("Dependent items error:", error);
      }
    }
  };

  // 🚀 MAIN FETCH LOGIC (With Strict Frontend Filter Fallback)
  const fetchStockReport = async (customMetal = metal, customPurity = purity, customStatus = statusFilter, customGroup = itemGroup, customItem = item) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${baseURL}/api/stock-report/?metal=${customMetal}&purity=${customPurity}&status=${customStatus}`
      );
      const result = await response.json();
      
      if (result.success === true) {
        let finalData = result.data;
        
        // Agar Detailed Search se Item Name select kiya gaya hai, to yahan data filter hoga
        if (customItem && customItem.trim() !== '') {
            finalData = finalData.filter(row => {
                return row.itemName && row.itemName.trim().toLowerCase() === customItem.trim().toLowerCase();
            });
        }

        setStockData(finalData);
        setShowReport(true);
      } else {
        alert("Error: " + result.message);
      }
    } catch (err) {
      alert("Server connect nahi ho paya!");
    } finally {
      setLoading(false);
    }
  };

  // 🚀 QUICK SEARCH LOGIC (100% Independent & Override)
  const handleQuickSearch = (type, value) => {
    // 1. Sabse pehle UI ke saare Detail Search dibbe khali (Reset) karo
    setMetal('');
    setPurity('');
    setItemGroup('');
    setItem('');
    setStatusFilter('');

    // 2. Sirf aur sirf Quick Search ki specific request API ko bhejo
    if (type === 'status') {
      setStatusFilter(value); // UI me set karega
      fetchStockReport('', '', value, '', ''); // Baki sab blank jayega
    } else if (type === 'metal_purity') {
      setMetal(value.m); 
      setPurity(value.p);
      fetchStockReport(value.m, value.p, '', '', ''); // Status, Group, Item sab blank jayega
    }
  };

  return (
    <div className="register-container">
      <div className="tagstock-branding-header">
        <h2>Tagwise Stock Details</h2>
      </div>
      
      <div className="tagstock-main-card">
        
        {/* 1. DETAILED SEARCH */}
        <fieldset className="tagstock-fieldset">
          <legend>Detailed Search</legend>
          <div className="tagstock-search-grid">
            
            <div className="tagstock-input-box">
              <label>Metal</label>
              <select value={metal} onChange={handleMetalChange}>
                <option value="">All Metals</option>
                {masterMetals.map((m, idx) => (
                  <option key={idx} value={m}>{m}</option>
                ))}
              </select>
            </div>

            <div className="tagstock-input-box">
              <label>Purity</label>
              <select value={purity} onChange={handlePurityChange} disabled={!metal}>
                <option value="">All Purities</option>
                {masterPurities.map((p, idx) => (
                  <option key={idx} value={p}>{p}</option>
                ))}
              </select>
            </div>

            <div className="tagstock-input-box">
              <label>Item Group</label>
              <select value={itemGroup} onChange={handleGroupChange} disabled={!purity}>
                <option value="">All Groups</option>
                {masterGroups.map((g, idx) => (
                  <option key={idx} value={g}>{g}</option>
                ))}
              </select>
            </div>

            <div className="tagstock-input-box">
              <label>Item Name</label>
              <select value={item} onChange={(e) => setItem(e.target.value)} disabled={!itemGroup}>
                <option value="">All Items</option>
                {masterItems.map((i, idx) => (
                  <option key={idx} value={i}>{i}</option>
                ))}
              </select>
            </div>

            <div className="tagstock-input-box tagstock-btn-wrapper">
              <button className="btn-show" onClick={() => fetchStockReport()}>
                Show Report
              </button>
            </div>

          </div>
        </fieldset>

        {/* 2. QUICK SEARCH */}
        <fieldset className="tagstock-fieldset">
          <legend>Quick Search</legend>
          <div className="tagstock-quick-grid">
            {[
              { label: 'Sold', action: () => handleQuickSearch('status', 'Sold'), bg: '#ef4444' },
              { label: 'Gold', action: () => handleQuickSearch('metal_purity', { m: 'Gold', p: '' }), bg: '#f59e0b' },
              { label: 'Gold 22', action: () => handleQuickSearch('metal_purity', { m: 'Gold', p: '22' }), bg: '#f59e0b' },
              { label: 'Gold 18', action: () => handleQuickSearch('metal_purity', { m: 'Gold', p: '18' }), bg: '#f59e0b' },
              { label: 'In Stock', action: () => handleQuickSearch('status', 'Available'), bg: '#10b981' },
              { label: 'Silver', action: () => handleQuickSearch('metal_purity', { m: 'Silver', p: '' }), bg: '#06b6d4' },
              { label: 'Silver 92.5', action: () => handleQuickSearch('metal_purity', { m: 'Silver', p: '92.5' }), bg: '#06b6d4' },
              { label: 'Silver CB', action: () => handleQuickSearch('metal_purity', { m: 'Silver', p: 'CB' }), bg: '#06b6d4' }
            ].map((btn, index) => (
              <button 
                key={index}
                onClick={btn.action}
                style={{ backgroundColor: btn.bg }}
                className="btn-quick-touch"
              >
                {btn.label}
              </button>
            ))}
          </div>
        </fieldset>

      </div>

      {loading && <p className="tagstock-loader-text">Stock data load ho raha hai...</p>}

      {showReport && !loading && (
        <div className="print-actions no-print">
          <button className="btn-print" onClick={window.print}>🖨️ Print / Save as PDF</button>
        </div>
      )}

      {/* --- REPORT SHEET (A4 PDF VIEW) --- */}
      {showReport && !loading && (
        <div className="report-paper-view-wrapper">
          <div className="report-paper-view">
            <div className="a4-print-sheet">
             <div className="report-header">
              <div className="logo-placeholder">{firmProfile.invoice_prefix || 'TJ'}</div>
              <div className="company-details">
                <h1>{firmProfile.firm_name}</h1>
                <p>{firmProfile.address_line_1}, {firmProfile.address_line_2}</p>
              </div>
              <div className="report-meta-info">
                <h3>Tagwise Stock Report</h3>
                <p>Status: {statusFilter || 'All'} | Metal: {metal || 'All'} | Purity: {purity || 'All'}</p>
              </div>
            </div>

              <table className="register-print-table">
                <thead>
                  <tr>
                    <th style={{ width: '8%' }}>Sl no.</th>
                    <th style={{ width: '15%' }}>Tag ID</th>
                    <th style={{ textAlign: 'left' }}>Item Name</th>
                    <th style={{ width: '12%' }}>Purity</th>
                    <th style={{ width: '15%' }}>Current Status</th>
                    <th style={{ width: '15%', textAlign: 'right' }}>Weight (g)</th>
                    <th style={{ width: '20%', textAlign: 'left' }}>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {stockData.length === 0 ? (
                    <tr>
                      <td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: '#777' }}>Koi stock data nahi mila</td>
                    </tr>
                  ) : (
                    stockData.map((row, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ fontWeight: 'bold' }}>{row.tagId}</td>
                        <td style={{ textAlign: 'left' }}>{row.itemName}</td>
                        <td>{row.purity}</td>
                        <td style={{ fontWeight: 'bold', color: row.status === 'Sold' ? '#ef4444' : '#10b981' }}>{row.status}</td>
                        <td style={{ textAlign: 'right', fontWeight: '600' }}>{row.weight}</td>
                        <td style={{ textAlign: 'left' }}>{row.remarks || '-'}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TagwiseStock;